import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeScreen from './screens/HomeScreen';
import QuizVariantSelectionScreen from './screens/QuizVariantSelectionScreen';
import TimedDifficultySelectionScreen from './screens/TimedDifficultySelectionScreen';
import TimedQuizPersonalizedScreen from './screens/TimedQuizPersonalizedScreen';
import TimedQuizRandomScreen from './screens/TimedQuizRandomScreen';
import NormalQuizPersonalizedScreen from './screens/NormalQuizPersonalizedScreen';
import NormalQuizRandomScreen from './screens/NormalQuizRandomScreen';
import './App.css'; // Contains the .phone-container styling

const App = () => {
  return (
    <div className="phone-container">
      <Router>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/quiz-variant" element={<QuizVariantSelectionScreen />} />
          <Route path="/timed-difficulty" element={<TimedDifficultySelectionScreen />} />
          <Route path="/timed-personalized" element={<TimedQuizPersonalizedScreen />} />
          <Route path="/timed-random" element={<TimedQuizRandomScreen />} />
          <Route path="/normal-personalized" element={<NormalQuizPersonalizedScreen />} />
          <Route path="/normal-random" element={<NormalQuizRandomScreen />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
